import React from 'react'

import { BoxHeadline, Box, Label } from 'shared/ui'
import { isEmpty } from 'util/objects'
import { propFunc } from 'util/functions'

import DirectionToggle from './DirectionToggle'
import styles from './styles.css'

const MergeHeader = props => {
  const { ticket, direction, onSwap } = props
  if (!ticket || isEmpty(ticket)) return null

  return (
    <Box ml={4} className={styles.headerWrapper}>
      <Label as="div" mt={3} size="large">
        Merge Conversation
      </Label>
      <BoxHeadline as="div" mt={2} color="gray" key={ticket.id}>
        {ticket.title}
      </BoxHeadline>
      <DirectionToggle
        direction={direction}
        onClick={propFunc(onSwap, ticket.id)}
      />
    </Box>
  )
}

export default MergeHeader
